import React from 'react';
import styled from 'styled-components';

const LoadingState = styled.div`
min-height: 200px;
display: flex;
align-items: center;
justify-content: center;
& > .lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
& > .lds-ripple div {
  position: absolute;
  border: 4px solid rgb(125 105 217 / 26%);
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
& > .lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}
`;

const WeFixItLoadingState = () => {
  return (
    <LoadingState>
      <div class="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </LoadingState>);
}

export default WeFixItLoadingState;